import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import type { SwiperOptions } from 'swiper/types';
import { MatDialog } from '@angular/material/dialog';
import { CategoryDialogComponent } from './category-dialog/category-dialog.component';
import { Data, AppService } from '../../app.service';
import {Category, Product} from "../../app.models";
import { Settings, AppSettings } from 'src/app/app.settings';

@Component({
    selector: 'app-category-carousel',
    templateUrl: './category-carousel.component.html',
    styleUrls: ['./category-carousel.component.scss'],
    standalone: false
})
export class CategoryCarouselComponent implements OnInit {

  @Input('categories') categories: Array<Category> = [];
  public config: SwiperOptions = {};
  public settings: Settings;
  constructor(public appSettings:AppSettings, public appService:AppService, public dialog: MatDialog, private router: Router) { 
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {

  }
  
  ngAfterViewInit(){
    this.config = {
      observer: true,
      slidesPerView: 1,
      spaceBetween: 16,       
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,        
      loop: false,
      breakpoints: {
        300:{
          slidesPerView: 2
        },
        480: {
          slidesPerView: 2
        },
        740: {
          slidesPerView: 3
        },
        960: {
          slidesPerView: 4
        },
        1280: {
          slidesPerView: 5
        },
        1500: {
          slidesPerView: 5
        }
      }
    }
  }

  public openProductDialog(product){   
    let dialogRef = this.dialog.open(CategoryDialogComponent, {
        data: product,
        panelClass: 'product-dialog',
        direction: (this.settings.rtl) ? 'rtl' : 'ltr'
    });
    dialogRef.afterClosed().subscribe(product => {
      if(product){
        this.router.navigate(['/products', product.id, product.name]); 
      }
    });
  }

}
